import palette from "../palette";

export default {
  root: {
    "&:hover $notchedOutline": {
      borderColor: palette.white,
    },
    "&$focused $notchedOutline": {
      borderColor: palette.white,
      borderWidth: 2,
    },
    // "&$focused $label": {
    //   color: "red",
    // },
  },
  notchedOutline: {
    borderColor: palette.text.primary,
  },
  adornedEnd: {
    paddingRight: 0,
  },
  input: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px #212121 inset",
      WebkitTextFillColor: 'white'
    },
  }
};
